module.exports = __webpack_public_path__ + "img/6.80e52be0.png";